import { ButtonsForUpdateTicket, Constants } from "../Utils/Constants.js";
import { sanitize } from "../Messages/Messages.js";

export const AdditionalDetails = ({ticketsRef,ticketAttachment, setFileHoverIndex, additionalDetails, getFileIcon, fileHoverIndex, removeFile, setAdditionalDetails, loadingDetails, isUiDisabled, handleSubmitDetails, handleCancelDetails, isAdditionalSubmitDisabled}) => {
    return (
        <div ref={ticketsRef} className="details-input-container mb-3">
            <p><span dangerouslySetInnerHTML={{ __html: sanitize(Constants.ATTACHMENTS.MESSAGE.TicketAttachmentMessage), }} /><i className="bi bi-info-circle-fill des-attach-tooltip" data-bs-toggle="tooltip" data-bs-placement="top" title={`Supported formats: ${Constants.ATTACHMENTS.VALUES.ALLOWED_EXTENSIONS} Max Limit: ${Constants.ATTACHMENTS.VALUES.MAX_FILES}`}></i></p>
            <div className="up-tic-attachment-preview-main">
                {ticketAttachment?.length > 0 &&
                ticketAttachment.map((item, index) => {
                    const isImage = (item.type.startsWith("image/"));
                    const isPdf = (item.type === "application/pdf");
                    const fileClass = !isImage ? "attachement_file_class" : "";
                    return (
                    <div key={index} className={`attachment-preview-child ${fileClass}`} onMouseEnter={() => setFileHoverIndex(index)} onMouseLeave={() => setFileHoverIndex(null)}>
                        <div className="attachment-preview">
                        {isImage && (<img src={item.preview} alt="preview" />)}
                        {!isImage && (getFileIcon(item.fileName))}
                        </div>
                        <div className={!fileClass ? "attachment_image_cls" : ""}>
                        {fileHoverIndex == index && (
                            <i
                            className="bi bi-x-circle-fill"
                            onClick={() => removeFile(index)}
                            ></i>
                        )
                        }

                        </div>
                    </div>
                    )
                })
                }
            </div>

            <h6 className="fw-semibold">Additional Details</h6>
            <textarea
                value={additionalDetails}
                onChange={(e) => setAdditionalDetails(e.target.value)}
                placeholder="Please enter additional details for this ticket"
                className="form-control"
                rows="4"
                disabled={loadingDetails || isUiDisabled}
            />

            <div className="d-flex justify-content-end gap-2 mt-2">
            {ButtonsForUpdateTicket(() => handleSubmitDetails("details"),loadingDetails ? "Submitting..." : "Submit Additional Details",2,isAdditionalSubmitDisabled)}
            {ButtonsForUpdateTicket(() => handleCancelDetails("details"),"Cancel",2,loadingDetails)}
            </div>
        </div>
    );
}